import React from 'react';
import { Trans } from '@lingui/react/macro';
import StatusReason from './StatusReason';
import { SpecificStatusReasonProps } from '.';

const RejectedStatusReason: React.FC<SpecificStatusReasonProps> = ({ ...rest }) => {
    return (
        <StatusReason
            titleGenerator={(userName) => (userName ? <Trans>Declined by {userName}</Trans> : <Trans>Declined</Trans>)}
            {...rest}
        />
    );
};

export default RejectedStatusReason;


